import { createContext, useContext } from "react";

export const SiteContext = createContext({ rooms: [], openBooking: () => {} });
export const useSite = () => useContext(SiteContext);
